export default __webpack_public_path__ + "static/media/tutorial_0.282334ff.svg";